<template>
  <v-row justify="center" class="mx-xl-6 mx-lg-6 mx-md-6" no-gutters v-if="_address">
    <v-col xl="8" lg="9" md="10" sm="12" cols="12">
      <v-row justify="center" class="pt-xl-4 pt-lg-4 pt-md-4 pb-xl-12 pb-lg-12 pb-md-8 pb-sm-4 pb-4" no-gutters>
        <v-col class="pr-xl-3 pr-lg-3 pr-md-3" cols="12">
          <v-card outlined>
            <v-toolbar flat dense color="#F9F9F9">
              <v-toolbar-title class="section-title px-2">Actualizar dirección</v-toolbar-title>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="text-left py-0 px-0">
              <address-form :address="_address" action="Guardar" @save="savedAddress"></address-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
  <div v-else>
    <form-loader></form-loader>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AddressForm from '@/components/Address/AddressForm'
import navigationMixin from '@/mixins/navigation'
import FormLoader from '@/loaders/FormLoader'
import { getErrorMessage } from '@/shared/errors'

export default {
  mixins: [navigationMixin],
  components: {
    AddressForm,
    FormLoader
  },
  computed: {
    ...mapState('shared', ['error', 'loading']),
    ...mapState('address', ['_address'])
  },
  methods: {
    ...mapActions('address', ['getAddress']),
    async savedAddress () {
      if (this.error) {
        this.$emit('notificationPopup', { icon: 'error', color: 'error', message: getErrorMessage('update_address', this.error) })
        return
      }

      this.$emit('notificationPopup', { icon: 'check_circle', color: 'success', message: 'dirección actualizada con éxito' })
      this.goToRouteByName('Addresses')
    }
  },
  mounted () {
    this.getAddress(this.$route.params.id)
  }
}
</script>
